import { FC, PropsWithChildren, useEffect, useRef } from 'react';

import { isMedia } from '@shared/lib/html';
import { GlobalPortal } from '@shared/ui/global-portal';

import { ModalWrapperProps } from './types';

import styles from './styles.module.scss';

/** Обёртка‑модалка: freeze body‑scroll и портал поверх всего */
export const ModalWrapper: FC<PropsWithChildren<ModalWrapperProps>> = ({ children, onMount }) => {
	const modalRef = useRef<HTMLDivElement>(null);

	/* freeze / unfreeze body scroll */
	const toggleFreeze = (freeze: boolean) => {
		const { body } = document;
		const isMobile = isMedia('sm');

		if (freeze) {
			body.classList.add(styles.Freeze);

			if (isMobile && body.style.position !== 'fixed') {
				const { scrollY } = window;
				body.style.position = 'fixed';
				body.style.top = `-${scrollY}px`;
			}
		} else {
			const wasOpened = body.classList.contains(styles.Freeze);
			body.classList.remove(styles.Freeze);

			if (isMobile) {
				const scrollY = body.style.top;
				body.style.position = '';
				body.style.top = '';

				if (wasOpened) {
					window.scrollTo(0, -Number.parseInt(scrollY || '0', 10));
				}
			}
		}
	};

	useEffect(() => {
		toggleFreeze(true);
		onMount?.();

		return () => toggleFreeze(false);
	}, []);

	return (
		<GlobalPortal>
			<div ref={modalRef} className={styles.Modal}>
				{children}
			</div>
		</GlobalPortal>
	);
};
